module.exports = __webpack_public_path__ + "img/88.05a1f071.jpg";